<template>
  <div class="sidebar" :data-color="activeColor">
    <div class="logo text-center">
      <a href="/dashboard" class="headline" style="color: #424242"
        >Semanggi App</a
      >
    </div>
    <div class="sidebar-wrapper">
      <slot name="content"></slot>
      <md-list class="nav" style="margin-bottom: 40px">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot>
          <sidebar-link
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :to="link.path"
            :link="link"
          >
          </sidebar-link>
        </slot>
      </md-list>
    </div>
    <v-footer
      absolute
      padless
      style="background-color: transparent; z-index: 999"
    >
      <!-- <v-btn tile block color="error"  @click="logout()" class="white--text">
        <md-icon>logout</md-icon>
        Logout
      </v-btn> -->
      <v-btn block color="error" @click="logout()"
        ><md-icon class="mr-1" style="margin: 0; color: #fff !important"
          >logout</md-icon
        >
        Logout</v-btn
      >
    </v-footer>
  </div>
</template>
<script>
import SidebarLink from "./SidebarLink.vue";
import { mapActions } from "vuex";

export default {
  components: {
    SidebarLink,
  },
  props: {
    title: {
      type: String,
      default: "Vue MD",
    },
    // backgroundImage: {
    //   type: String,
    //   default: require("@/assets/img/sidebar-2.jpg")
    // },
    imgLogo: {
      type: String,
      default: require("@/assets/img/vue-logo.png"),
    },
    activeColor: {
      type: String,
      default: "green",
      validator: (value) => {
        let acceptedValues = ["", "purple", "blue", "green", "orange", "red"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
    ...mapActions({
      logOut: "auth/logOut",
    }),
    logout() {
      let result = confirm("Are you sure you want to logout?");
      if (result) {
        this.logOut();
      }
    },
  },
  computed: {
    // sidebarStyle() {
    //   return {
    //     backgroundImage: `url(${this.backgroundImage})`
    //   };
    // }
  },
};
</script>
<style>
/* .sidebar{
  background-color: #348e6b !important;
} */
@media screen and (min-width: 991px) {
  .nav-mobile-menu {
    display: none;
  }
}
</style>
